import { HomeDataResponse } from '@shared/home-sections/entities/home-data.response';
import { UserHistoryItem } from '@app/modules/user-history/entities/user-history-item';

export const homeFeatureName = 'homeModuleState';

export type UiHomeState = Readonly<{
  isLoadingHome: boolean,
  isLoadingHistory: boolean
}>;

export type HomeModuleState = Readonly<{
  homeData: HomeDataResponse,
  userHistory: UserHistoryItem[]
  ui: UiHomeState
}>;
